export default "__VITE_ASSET__B$YgKK2w__"